import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "settings-users-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Change Password"),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0 sub-title" }, [
    /*#__PURE__*/_createElementVNode("small", null, "Modify your current password")
  ])
], -1)
const _hoisted_3 = { class: "card mb-10 pt-10 px-5" }
const _hoisted_4 = { class: "card-body d-flex flex-column" }
const _hoisted_5 = { class: "w-lg-40 w-100 mx-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navigator = _resolveComponent("Navigator")!
  const _component_NewPasswordForm = _resolveComponent("NewPasswordForm")!
  const _component_ChangePasswordForm = _resolveComponent("ChangePasswordForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navigator, {
      to: "/settings",
      text: "Back to settings"
    }),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.authUser.create_new_password)
            ? (_openBlock(), _createBlock(_component_NewPasswordForm, {
                key: 0,
                onSubmitForm: _ctx.handleSubmitForm,
                loading: _ctx.loading,
                ref: "newPasswordForm"
              }, null, 8, ["onSubmitForm", "loading"]))
            : (_openBlock(), _createBlock(_component_ChangePasswordForm, {
                key: 1,
                onSubmitForm: _ctx.handleSubmitForm,
                ref: "changePasswordForm",
                loading: _ctx.loading
              }, null, 8, ["onSubmitForm", "loading"]))
        ])
      ])
    ])
  ]))
}